// extracted by mini-css-extract-plugin
export default {"tooltip":"Rn-z","sharingV2":"Sn-z","sharingIconsV2":"Tn-z","links":"Un-z","link":"Vn-z","facebookV2":"Wn-z","twitterV2":"Xn-z","pinterestV2":"Yn-z"};